"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthProviders = void 0;
exports.AuthProviders = {
    KAKAO: '카카오',
};
